<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <div id="app">
    <Header/> 
    <!-- <div class="temp-text">
      <div>Onze website is momenteel in aanbouw en we werken hard om een vernieuwde ervaring voor je te creëren. Binnenkort is de site helemaal klaar en kun je alles ontdekken wat we voor jou in petto hebben. Bedankt voor je geduld, we kunnen niet wachten om je snel online te verwelkomen! </div>
    </div> -->
  </div>
  <router-view /> 
    <Footer/>

</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Header from './components/Header.vue'

import Footer from './components/Footer.vue'


export default {
  name: 'App',
  components: {
    // HelloWorld
    Header,
    Footer
  },
  methods: {
    menuClicked() {
        let menu = document.querySelector('#menu-btn');
        let navbar = document.querySelector('.header .nav');
        menu.classList.toggle('fa-times');
        navbar.classList.toggle('active');

        console.log(menu);
        console.log(navbar);

      },
      handleScroll () {
      // Any code to be executed when the window is scrolled
      
        let menu = document.querySelector('#menu-btn');
        let navbar = document.querySelector('.header .nav');
        menu.classList.remove('fa-times');
        navbar.classList.remove('active');

        let header = document.querySelector('.header');
        if(window.scrollY > 0) {
          header.classList.add('active');
        }
        else {
          header.classList.remove('active');
        }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style>
/* global */
:root {
  --blue: #00b8b8;
  --black: #333;
  --white: #fff;
  --light-color: #666;
  --light-bg: #eee;
  --border: .2rem solid rgba(0,0,0,.1);
  --box-shadow: 0 0.5rem 1rem rgba(0,0,0,.1);
}
#app {
  font-family: 'Poppins', sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
  border: none;
  text-decoration: none;
  /* text-transform: capitalize; */
}
*::-webkit-scrollbar {
  height: 0.5rem;
  width: 1rem;
}
*::-webkit-scrollbar-track {
  background-color: transparent;
}
*::-webkit-scrollbar-thumb {
  background-color: var(--blue);
}
html {
  font-size: 62.5%;
  overflow-x: hidden;
  scroll-behavior: smooth;
  scroll-padding-top: 6.5rem;
}
section {
  padding: 7rem 2rem;
}
.heading {
  text-align: center;
  font-size: 4rem;
  color: var(--black);
  /* text-transform: uppercase; */
  font-weight: bolder;
  margin-bottom: 3rem;
}
.link-btn {
  display: inline-block;
  padding: 1rem 3rem;
  border-radius: 8px; /* rondere hoeken voor moderne look */
  background-color: var(--blue);
  cursor: pointer;
  font-size: 1.7rem;
  color: var(--white);
  transition: all 0.3s ease; /* soepelere transitie */
  font-weight: 600; /* iets zwaarder lettertype */
  box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* subtiele schaduw */
  text-decoration: none;
  white-space: nowrap; /* voorkomt dat tekst op nieuwe regel komt */
}
.link-btn:hover {
  background-color: var(--black);
  color: var(--white);
  text-decoration: none;
  transform: translateY(-1px); /* lichte lift effect */
  box-shadow: 0 4px 8px rgba(0,0,0,0.15); /* versterkte schaduw */
}

/* Contact link styling */
.contact-link {
  color: var(--blue);
  text-decoration: none;
  transition: color 0.3s ease;
}
.contact-link:hover {
  color: var(--black);
  text-decoration: underline;
}

.row-custom {
    /* margin-top: 30px; */
    display: flex;
    justify-content: space-between;
}

/* media queries */
@media (max-width: 991px) {
  /* global */
  html {
    font-size: 55%;
  }
  section {
  padding: 5rem 2rem;
}

  
}
@media (max-width: 768px) {
  /* global */
  section {
    padding: 3rem 1rem;
  }
}
@media (max-width: 450px) {
  html {
    font-size: 50%;
  } 
  .heading {
    font-size: 3rem;
  }
}

/* .temp-text {
  margin: auto;
  width: 100%;
  border: 1px solid #00b8b8;
  padding: 10px;
  font-size: 20px;
}

#app {
  margin: 50px 20px;
} */
</style>
